var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61666 16.1955C4.10832 16.1955 3.63332 16.0212 3.29166 15.6977C2.85832 15.2911 2.64999 14.6772 2.72499 14.0134L3.03332 11.3253C3.09166 10.8192 3.39999 10.1472 3.75832 9.78211L10.6 2.57228C12.3083 0.771895 14.0917 0.722115 15.9 2.42294C17.7083 4.12376 17.7583 5.89925 16.05 7.69964L9.20832 14.9095C8.85832 15.2828 8.20832 15.6313 7.69999 15.7142L5.01666 16.1706C4.87499 16.1789 4.74999 16.1955 4.61666 16.1955ZM13.275 2.41464C12.6333 2.41464 12.075 2.81288 11.5083 3.41024L4.66666 10.6284C4.49999 10.8026 4.30832 11.2174 4.27499 11.458L3.96666 14.1462C3.93332 14.42 3.99999 14.644 4.14999 14.785C4.29999 14.9261 4.52499 14.9758 4.79999 14.9344L7.48332 14.478C7.72499 14.4366 8.12499 14.2208 8.29166 14.0466L15.1333 6.83678C16.1667 5.74162 16.5417 4.72942 15.0333 3.31898C14.3667 2.68013 13.7917 2.41464 13.275 2.41464Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4504 9.08603C14.4338 9.08603 14.4088 9.08603 14.3921 9.08603C11.7921 8.82884 9.70044 6.86252 9.30044 4.29054C9.25044 3.95038 9.48378 3.6351 9.82544 3.57703C10.1671 3.52725 10.4838 3.75955 10.5421 4.09972C10.8588 6.10752 12.4921 7.6507 14.5254 7.84982C14.8671 7.88301 15.1171 8.18999 15.0838 8.53015C15.0421 8.84543 14.7671 9.08603 14.4504 9.08603Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.8773H2.5C2.15833 18.8773 1.875 18.5952 1.875 18.2551C1.875 17.9149 2.15833 17.6328 2.5 17.6328H17.5C17.8417 17.6328 18.125 17.9149 18.125 18.2551C18.125 18.5952 17.8417 18.8773 17.5 18.8773Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b4b77584d7d90d09772152b24a99cb3d.svg";
export { ForwardRef as ReactComponent };